import { sendPage, sendEvent, sendImpressions } from 'reaxl-analytics';
import { useStore } from 'react-redux';
import { getConsumerMetadata } from '@atc/consumer-metadata';
import {
    inventoryResultsDuck,
    inventoryFiltersDuck,
    inventoryPaginationDuck,
    inventoryActiveOwnerDuck,
} from '../ducks';
import { get as _get } from '../utilities/common';
import { getTabName } from '../utilities';
import { TAB_ANALYTICS_NAME } from '../constants';

export default function useCreateDealerDetailsPageEvent() {
    const store = useStore();
    return async ({
        isInitialLoad = false,
        event,
    } = {}) => {
        const consumerMetadata = await getConsumerMetadata();
        const state = store.getState();
        const dataIsland = _get(state, 'birf.pageData', {});

        // Get the active dealer/owner ID
        const activeOwner = inventoryActiveOwnerDuck.selectors.getDuckState(state);
        const owner = _get(state.owners, activeOwner, {});
        const ownerId = owner.id;

        sendPage({
            dataIsland,
            domainKey: 'dealerdetails',
            isInitialLoad,
            filterDuck: inventoryFiltersDuck,
            paginationDuck: inventoryPaginationDuck,
            resultsDuck: inventoryResultsDuck,
            event,
            data: {
                consumerMetadata,
                listingCode: ownerId,
            },
        });

        if (!isInitialLoad) {
            sendEvent({
                name: 'search',
                type: 'search',
                dataIsland,
            });
        }
        // send new inventory impressions
        if (getTabName(state) === TAB_ANALYTICS_NAME.sales) {
            sendImpressions({
                name: 'inventoryImpressions',
                data: { cmp: 'dealerdetails', isSingle: false },
                resultsDuck: inventoryResultsDuck,
            });
        }

    };
}
